/* ═══════════════════════════════════════════
   FWG Automotive Styling Inquiry Form — JS
   Supabase Integration · Shopify-ready
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

/* ── Supabase Config ── */
var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

// ───────────────────────────────────────
//  STEPPER NAVIGATION
// ───────────────────────────────────────
var TOTAL_STEPS = 5;
var currentStep = 1;
var completedSteps = new Set();

function goToStep(target) {
  if (target < 1 || target > TOTAL_STEPS || target === currentStep) return;
  var isForward = target > currentStep;
  if (isForward) {
    for (var s = currentStep; s < target; s++) {
      var errors = getStepErrors(s);
      if (errors.length > 0) { highlightErrors(s, errors); showToast('Please fill in all required fields'); return; }
      completedSteps.add(s);
    }
  }
  if (!isForward && getStepErrors(currentStep).length === 0) completedSteps.add(currentStep);
  switchCard(target);
}
// Expose to inline onclick
window.goToStep = goToStep;

function switchCard(target) {
  var cc = document.querySelector('.step-card[data-step="'+currentStep+'"]');
  if (cc) cc.classList.remove('active');
  if (target === 5) buildSummary();
  var tc = document.querySelector('.step-card[data-step="'+target+'"]');
  if (tc) { void tc.offsetWidth; tc.classList.add('active'); }
  currentStep = target;
  updateStepper();
  var stepper = document.getElementById('stylingFormStepper');
  if (stepper) {
    stepper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function getStepErrors(stepNum) {
  var errors = [];
  switch (stepNum) {
    case 1:
      if (!document.getElementById('contactName').value.trim()) errors.push('contactName');
      if (!document.getElementById('email').value.trim()) errors.push('email');
      if (!document.getElementById('phone').value.trim()) errors.push('phone');
      if (!document.getElementById('contactMethodHidden').value) errors.push('contactMethod');
      break;
    case 2:
      var blocks = document.querySelectorAll('#vehicleBlocksContainer .vehicle-block');
      var anyType = false;
      blocks.forEach(function(b) { if (b.querySelector('.vtype-hidden') && b.querySelector('.vtype-hidden').value) anyType = true; });
      if (!anyType) errors.push('vehicleType');
      break;
    case 3:
      if (!document.getElementById('servicesHidden').value) errors.push('services');
      break;
    case 4:
      if (!document.getElementById('timeline').value) errors.push('timeline');
      break;
  }
  return errors;
}

function highlightErrors(stepNum, errors) {
  document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); });
  var card = document.querySelector('.step-card[data-step="'+stepNum+'"]');
  if (!card) return;
  card.classList.remove('shake'); void card.offsetWidth; card.classList.add('shake');
  errors.forEach(function(k) {
    switch(k) {
      case 'contactName': case 'email': case 'phone':
        var el = document.getElementById(k); if (el) el.closest('.field-group').classList.add('field-error'); break;
      case 'contactMethod':
        var cm = document.querySelector('.contact-method-group'); if (cm) cm.closest('.field-group').classList.add('field-error'); break;
      case 'vehicleType':
        var vg = document.querySelector('.vtype-grid'); if (vg) vg.closest('.field-group').classList.add('field-error'); break;
      case 'services':
        var sg = document.querySelector('.service-grid'); if (sg) sg.closest('.field-group').classList.add('field-error'); break;
      case 'timeline':
        var tl = document.getElementById('timeline'); if (tl) tl.closest('.field-group').classList.add('field-error'); break;
    }
  });
}

document.addEventListener('input', function() { document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); }); });
document.addEventListener('click', function(e) { if (e.target.closest('.contact-method-btn, .service-btn, .vtype-card')) document.querySelectorAll('.field-error').forEach(function(el) { el.classList.remove('field-error'); }); });

function updateStepper() {
  document.querySelectorAll('.step-indicator').forEach(function(ind) {
    var step = parseInt(ind.dataset.step);
    ind.classList.remove('active', 'completed');
    if (step === currentStep) ind.classList.add('active');
    else if (completedSteps.has(step)) ind.classList.add('completed');
  });
}

// ───────────────────────────────────────
//  SERVICES (multi-select with detail panels)
// ───────────────────────────────────────
var selectedServices = new Set();

var serviceDetailMap = {
  printed_wraps: 'detail_printed_wraps',
  color_change: 'detail_color_change',
  styling_graphics: 'detail_styling_graphics',
  tuxedo_roof: 'detail_tuxedo_roof',
  chrome_delete: 'detail_chrome_delete',
  custom_taillights: 'detail_custom_taillights',
  racing_stripes: 'detail_racing_stripes',
  custom_decals: 'detail_custom_decals',
  window_flags: 'detail_window_flags',
  other: 'detail_other'
};

function toggleService(btn) {
  var val = btn.dataset.value;
  if (selectedServices.has(val)) {
    selectedServices.delete(val);
    btn.classList.remove('selected');
  } else {
    selectedServices.add(val);
    btn.classList.add('selected');
  }
  document.getElementById('servicesHidden').value = Array.from(selectedServices).join(',');
  updateServicePanels();
}
window.toggleService = toggleService;

function updateServicePanels() {
  Object.keys(serviceDetailMap).forEach(function(key) {
    var panel = document.getElementById(serviceDetailMap[key]);
    if (panel) {
      if (selectedServices.has(key)) panel.classList.add('visible');
      else panel.classList.remove('visible');
    }
  });
}

function selectArtworkStatus(svcKey, btn) {
  var group = btn.closest('.artwork-btn-group');
  group.querySelectorAll('.artwork-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  var hidden = document.getElementById(svcKey + '_file_status');
  if (hidden) hidden.value = btn.dataset.value;
}
window.selectArtworkStatus = selectArtworkStatus;

function selectTuxType(btn) {
  document.querySelectorAll('.tux-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('tuxedoTypeHidden').value = btn.dataset.value;
  var cond = document.getElementById('tuxedoConditional');
  if (btn.dataset.value === 'tuxedo_top') cond.classList.add('visible');
  else { cond.classList.remove('visible'); document.getElementById('tuxedoUploadSection').classList.remove('visible'); }
}
window.selectTuxType = selectTuxType;

function selectTuxLook(btn) {
  var group = btn.closest('.artwork-btn-group');
  group.querySelectorAll('.artwork-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('tuxedoLookHidden').value = btn.dataset.value;
  var uploadSection = document.getElementById('tuxedoUploadSection');
  if (btn.dataset.value === 'specific') uploadSection.classList.add('visible');
  else uploadSection.classList.remove('visible');
}
window.selectTuxLook = selectTuxLook;

// ───────────────────────────────────────
//  CONTACT METHOD
// ───────────────────────────────────────
function selectContactMethod(btn) {
  document.querySelectorAll('.contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('contactMethodHidden').value = btn.dataset.value;
}
window.selectContactMethod = selectContactMethod;

// ───────────────────────────────────────
//  DATA
// ───────────────────────────────────────
var vehicleCounter = 0;
var container = document.getElementById('vehicleBlocksContainer');
var countDisplay = document.getElementById('vehicleCountDisplay');

var yearOptions = [];
for (var y = 2026; y >= 2016; y--) yearOptions.push(String(y));

var vehicleColors = [
  {value:'white',label:'White',hex:'#FFFFFF'},{value:'black',label:'Black',hex:'#1A1A1A'},
  {value:'gray',label:'Gray',hex:'#808080'},{value:'silver',label:'Silver',hex:'#C0C0C0'},
  {value:'blue',label:'Blue',hex:'#2B5EA7'},{value:'red',label:'Red',hex:'#C0392B'},
  {value:'brown',label:'Brown',hex:'#6B4226'},{value:'green',label:'Green',hex:'#2E7D32'},
  {value:'beige',label:'Beige / Tan',hex:'#C8B88A'},{value:'yellow',label:'Yellow',hex:'#F1C40F'},
  {value:'orange',label:'Orange',hex:'#E67E22'},{value:'other',label:'Other',hex:null}
];

var wrapColors = [
  {value:'white',label:'White',hex:'#FFFFFF'},{value:'black',label:'Black',hex:'#1A1A1A'},
  {value:'gray',label:'Gray',hex:'#808080'},{value:'silver',label:'Silver',hex:'#C0C0C0'},
  {value:'blue',label:'Blue',hex:'#2B5EA7'},{value:'red',label:'Red',hex:'#C0392B'},
  {value:'brown',label:'Brown',hex:'#6B4226'},{value:'green',label:'Green',hex:'#2E7D32'},
  {value:'beige',label:'Beige / Tan',hex:'#C8B88A'},{value:'yellow',label:'Yellow',hex:'#F1C40F'},
  {value:'orange',label:'Orange',hex:'#E67E22'},{value:'purple',label:'Purple',hex:'#7B2D8E'},
  {value:'pink',label:'Pink',hex:'#E84393'},{value:'teal',label:'Teal',hex:'#008B8B'},
  {value:'other',label:'Other (describe below)',hex:null}
];

var typeExamples = {
  coupe_sedan:      { make:'Toyota', model:'Camry' },
  small_suv:        { make:'Mazda',  model:'CX-5' },
  midsize_suv:      { make:'Toyota', model:'Land Cruiser' },
  pickup:           { make:'Toyota', model:'Tacoma' },
  golf_atv_utv:     { make:'',       model:'' },
  watercraft:       { make:'',       model:'' }
};

var vehicleTypes = [
  { value:'coupe_sedan', label:'Coupe / Sedan', example:'Camry, Accord, Mustang, etc.', fields:[] },
  { value:'small_suv', label:'Crossover / Small SUV', example:'CX-5, Bronco Sport, GLA 250', fields:[] },
  { value:'midsize_suv', label:'Mid / Full SUV', example:'Land Cruiser, Santa Fe, Suburban', fields:[] },
  { value:'pickup', label:'Pickup Truck', example:'Tacoma, Silverado, F-250', fields:['cab_size','bed_size'] },
  { value:'golf_atv_utv', label:'Golf Cart | ATV | UTV', example:'E-Z-GO, Polaris RZR, Can-Am, etc.', fields:[] },
  { value:'watercraft', label:'Water Craft', example:'Boats, Ski\u2019s, etc.', fields:[] }
];

var conditionalOptions = {
  cab_size: { label:'Cab Size', options:['Standard Cab','Extended Cab','Full Cab'] },
  bed_size: { label:'Bed Size', options:['Short Bed','Standard Bed','Long Bed'] }
};

var icons = {
  copy:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3H4a1 1 0 00-1 1v14"/><rect x="8" y="7" width="13" height="14" rx="1"/></svg>',
  duplicate:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><line x1="17.5" y1="14" x2="17.5" y2="21"/><line x1="14" y1="17.5" x2="21" y2="17.5"/></svg>',
  remove:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
  upload:'<svg class="file-upload__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
  chevron:'<svg class="color-picker__chevron" viewBox="0 0 12 8" fill="none" stroke="#7D7D7D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l5 5 5-5"/></svg>'
};

// ───────────────────────────────────────
//  BUILDERS
// ───────────────────────────────────────
function buildYearHTML(sel) {
  var isOlder = sel && !yearOptions.includes(sel);
  var sv = isOlder ? 'older' : sel;
  var h = '<option value="" disabled '+ (!sv?'selected':'') +'>Select year</option>';
  yearOptions.forEach(function(y) { h += '<option value="'+y+'" '+(sv===y?'selected':'')+'>'+y+'</option>'; });
  h += '<option value="older" '+(sv==='older'?'selected':'')+'>My vehicle is older than 2016</option>';
  return h;
}

function buildColorOptionsHTML(bid, colorList) {
  var list = colorList || vehicleColors;
  return list.map(function(c) {
    var ss = c.hex ? 'style="background:'+c.hex+';"' : '';
    var sc = c.value==='other' ? 'color-picker__swatch color-picker__swatch--other' : 'color-picker__swatch';
    return '<div class="color-picker__option" data-value="'+c.value+'" data-label="'+c.label+'" data-hex="'+(c.hex||'')+'" onclick="selectColor(\''+bid+'\',this)"><span class="'+sc+'" '+ss+'>'+(c.value==='other'?'?':'')+'</span><span class="color-picker__option-label">'+c.label+'</span></div>';
  }).join('');
}

function buildVehicleTypeSelector(bid, sel) {
  return '<div class="field-group"><label class="field-label">Vehicle Type <span class="required">*</span></label><div class="vtype-grid">' +
    vehicleTypes.map(function(vt) { return '<div class="vtype-card '+(sel===vt.value?'selected':'')+'" data-vtype="'+vt.value+'" onclick="selectVehicleType('+bid+',\''+vt.value+'\')"><div class="vtype-card__label">'+vt.label+'</div><div class="vtype-card__example">'+vt.example+'</div></div>'; }).join('') +
    '</div><input type="hidden" class="vtype-hidden" name="v'+bid+'_type" value="'+(sel||'')+'" /></div>';
}

function buildConditionalFields(bid, vtv, p) {
  var vt = vehicleTypes.find(function(v) { return v.value === vtv; });
  if (!vt) return '';
  var ex = typeExamples[vtv] || { make:'Make', model:'Model' };
  var html = '';

  // Browsing checkbox
  html += '<div class="field-group"><label class="checkbox-option"><input type="checkbox" class="browsing-check" name="v'+bid+'_browsing" value="yes" '+(p.browsing?'checked':'')+' onchange="toggleBrowsing('+bid+')" /><span>I don\'t have this vehicle yet &mdash; just exploring options</span></label><div class="browsing-notice '+(p.browsing?'visible':'')+'" id="browsingNotice_'+bid+'">No problem! We can still prepare a general estimate based on the vehicle type and project scope.</div></div>';

  // Year / Make / Model
  html += '<div class="field-row" style="margin-bottom:16px;"><div class="field-group"><label class="field-label">Year <span class="required">*</span></label><select class="year-select">'+buildYearHTML(p.year)+'</select><input type="hidden" class="year-hidden" name="v'+bid+'_year" value="'+(p.year||'')+'" /><div class="older-vehicle-notice '+(p.year&&!yearOptions.includes(p.year)?'visible':'')+'"><span>&#9888;&#65039;</span> For vehicles older than 2016, we\'d like to see the vehicle in person to evaluate paint condition before quoting.<input type="number" class="older-year-input" placeholder="Enter vehicle year" min="1970" max="2015" value="'+(p.year&&!yearOptions.includes(p.year)?p.year:'')+'" /></div></div><div class="field-group"><label class="field-label">Make <span class="required">*</span></label><input type="text" name="v'+bid+'_make" placeholder="e.g. '+ex.make+'" value="'+(p.make||'')+'" /></div></div>';
  html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">Model <span class="required">*</span></label><input type="text" name="v'+bid+'_model" placeholder="e.g. '+ex.model+'" value="'+(p.model||'')+'" /></div>';

  // Conditional dropdowns
  vt.fields.forEach(function(fk) {
    var fd = conditionalOptions[fk];
    var val = p.conditionals ? (p.conditionals[fk]||'') : '';
    html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">'+fd.label+' <span class="required">*</span></label><select name="v'+bid+'_'+fk+'"><option value="" disabled '+(!val?'selected':'')+'>Select '+fd.label.toLowerCase()+'</option>'+fd.options.map(function(o){return '<option value="'+o+'" '+(val===o?'selected':'')+'>'+o+'</option>';}).join('')+'</select></div>';
  });

  // Color picker
  var tss='',tsi='',tlt='Select vehicle color',tlc='color-picker__trigger-label placeholder',ov=false;
  if(p.color){var m=vehicleColors.find(function(c){return c.value===p.color;});if(m){tlt=m.label;tlc='color-picker__trigger-label';if(p.color==='other'){tss='background:linear-gradient(135deg,#3A3A3A 25%,#2A2A2A 25%,#2A2A2A 50%,#3A3A3A 50%,#3A3A3A 75%,#2A2A2A 75%);background-size:8px 8px;';tsi='<span style="font-size:12px;font-weight:700;color:#7D7D7D;">?</span>';ov=true;}else{tss='background:'+m.hex+';';}}}
  var hcv=p.color==='other'&&p.colorOther?'other:'+p.colorOther:(p.color||'');
  html += '<div class="field-group" style="margin-bottom:16px;"><label class="field-label">Vehicle Color</label><div class="color-picker" data-block="'+bid+'"><input type="hidden" class="color-picker__hidden" name="v'+bid+'_color" value="'+hcv+'" /><button type="button" class="color-picker__trigger" onclick="toggleColorDropdown(\''+bid+'\')"><span class="color-picker__trigger-swatch" style="'+tss+'">'+tsi+'</span><span class="'+tlc+'">'+tlt+'</span>'+icons.chevron+'</button><div class="color-picker__dropdown">'+buildColorOptionsHTML(bid)+'</div><input type="text" class="color-picker__other-input '+(ov?'visible':'')+'" placeholder="Describe your vehicle color..." value="'+(p.colorOther||'')+'" /></div></div>';

  // Paint Condition
  var paintIssue = p.paintIssue || false;
  html += '<div class="field-group" style="margin-bottom:16px;">';
  html += '<label class="field-label">Paint Condition</label>';
  html += '<label class="checkbox-option"><input type="checkbox" class="paint-issue-check" name="v'+bid+'_paint_issue" value="yes" '+(paintIssue?'checked':'')+' onchange="togglePaintNotice('+bid+')" /><span>Does this vehicle have any paint imperfections? (scratches, chips, peeling, rust, clear coat damage, etc.)</span></label>';
  html += '<div class="paint-notice '+(paintIssue?'visible':'')+'" id="paintNotice_'+bid+'">';
  html += '<div class="paint-notice__header"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> Good to know!</div>';
  html += 'Paint imperfections such as scratches, chips, peeling, or oxidation can affect wrap adhesion and the final result. Any texture or damage beneath the surface will typically show through the wrap film. Additionally, <strong style="color:#E8C36A;">areas where the clear coat is damaged or missing will prevent the vinyl from adhering properly</strong>, which can lead to lifting, bubbling, or premature failure of the wrap in those spots. We may recommend paint correction or spot repair before installation for the best possible outcome.';
  html += '</div></div>';

  // Vehicle photos
  html += '<div class="field-group"><label class="field-label">Upload Vehicle Photos</label><span class="field-helper">Highly recommended &mdash; seeing your vehicle helps us provide the most accurate quote and identify any paint concerns.</span><div class="file-upload" id="upload'+bid+'">'+icons.upload+'<p class="file-upload__text"><strong>Click to upload</strong> or drag and drop</p><input type="file" name="v'+bid+'_photos" multiple accept="image/*" onchange="showFileNames(this,\'upload'+bid+'\')" /><div class="file-names"></div></div></div>';

  return html;
}

// ───────────────────────────────────────
//  VEHICLE BLOCK
// ───────────────────────────────────────
function createVehicleBlock(prefill) {
  vehicleCounter++;
  var num = vehicleCounter;
  var totalBlocks = container.querySelectorAll('.vehicle-block').length + 1;
  var p = prefill || {vtype:'',year:'',make:'',model:'',color:'',colorOther:'',conditionals:{},browsing:false,paintIssue:false,paintDesc:''};
  var block = document.createElement('div');
  block.className = 'vehicle-block'; block.dataset.id = num;
  var act = '';
  if (totalBlocks>1) act += '<button type="button" class="btn-vehicle-action btn-copy" onclick="copyFromFirst('+num+')">'+icons.copy+' Copy from Vehicle 1</button>';
  act += '<button type="button" class="btn-vehicle-action btn-duplicate" onclick="duplicateVehicle('+num+')">'+icons.duplicate+' Duplicate</button>';
  if (totalBlocks>1) act += '<button type="button" class="btn-vehicle-action btn-remove" onclick="removeVehicle('+num+')">'+icons.remove+' Remove</button>';
  block.innerHTML = '<div class="vehicle-block__top-bar"><span class="vehicle-block__title">Vehicle <span class="vb-num">'+totalBlocks+'</span></span><div class="vehicle-block__actions">'+act+'</div></div>'+buildVehicleTypeSelector(num,p.vtype)+'<div class="vtype-prompt" id="vtypePrompt_'+num+'" '+(p.vtype?'style="display:none;"':'')+'><svg class="vtype-prompt__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg><div class="vtype-prompt__text">Select a vehicle type above to continue</div></div><div class="conditional-fields '+(p.vtype?'visible':'')+'" id="cond_'+num+'">'+(p.vtype?buildConditionalFields(num,p.vtype,p):'')+'</div>';
  container.appendChild(block);
  if(p.color){var opt=block.querySelector('.color-picker__option[data-value="'+p.color+'"]');if(opt)opt.classList.add('selected');}
  updateVehicleNumbers();
  return num;
}

function selectVehicleType(bid, vtv) {
  var block = container.querySelector('.vehicle-block[data-id="'+bid+'"]');
  if(!block) return;
  block.querySelectorAll('.vtype-card').forEach(function(c){c.classList.remove('selected');});
  block.querySelector('.vtype-card[data-vtype="'+vtv+'"]').classList.add('selected');
  block.querySelector('.vtype-hidden').value = vtv;
  var prompt = block.querySelector('#vtypePrompt_'+bid); if(prompt) prompt.style.display = 'none';
  var cc = block.querySelector('.conditional-fields');
  cc.innerHTML = buildConditionalFields(bid, vtv, {year:'',make:'',model:'',color:'',colorOther:'',conditionals:{},browsing:false,paintIssue:false,paintDesc:''});
  cc.classList.add('visible');
}
window.selectVehicleType = selectVehicleType;

function toggleBrowsing(bid) {
  var block = container.querySelector('.vehicle-block[data-id="'+bid+'"]'); if(!block) return;
  var cb = block.querySelector('.browsing-check');
  var notice = block.querySelector('#browsingNotice_'+bid);
  if(cb.checked) notice.classList.add('visible'); else notice.classList.remove('visible');
}
window.toggleBrowsing = toggleBrowsing;

function togglePaintNotice(bid) {
  var block = container.querySelector('.vehicle-block[data-id="'+bid+'"]'); if(!block) return;
  var cb = block.querySelector('.paint-issue-check');
  var notice = block.querySelector('#paintNotice_'+bid);
  if(cb.checked) notice.classList.add('visible'); else notice.classList.remove('visible');
}
window.togglePaintNotice = togglePaintNotice;

// ───────────────────────────────────────
//  GET/SET DATA
// ───────────────────────────────────────
function getVehicleData(bid) {
  var block = container.querySelector('.vehicle-block[data-id="'+bid+'"]'); if(!block) return null;
  var vtype = (block.querySelector('.vtype-hidden')||{}).value||'';
  var yearEl = block.querySelector('.year-hidden'), makeEl = block.querySelector('[name$="_make"]'), modelEl = block.querySelector('[name$="_model"]');
  var colorEl = block.querySelector('.color-picker__hidden'), browseEl = block.querySelector('.browsing-check');
  var paintEl = block.querySelector('.paint-issue-check'), paintDescEl = block.querySelector('.paint-desc-input');
  var cv = colorEl?colorEl.value:'', co='';
  if(cv.startsWith('other:')){co=cv.substring(6);cv='other';}
  var conds = {};
  var vt = vehicleTypes.find(function(v){return v.value===vtype;});
  if(vt) vt.fields.forEach(function(fk){var s=block.querySelector('[name$="_'+fk+'"]');if(s)conds[fk]=s.value;});
  return {vtype:vtype, year:yearEl?yearEl.value:'', make:makeEl?makeEl.value:'', model:modelEl?modelEl.value:'', color:cv, colorOther:co, conditionals:conds, browsing:browseEl?browseEl.checked:false, paintIssue:paintEl?paintEl.checked:false, paintDesc:paintDescEl?paintDescEl.value:''};
}
function getFirstVehicleData() { var f=container.querySelector('.vehicle-block'); return f?getVehicleData(f.dataset.id):null; }

function copyFromFirst(tid) {
  var data=getFirstVehicleData(); if(!data) return;
  var block=container.querySelector('.vehicle-block[data-id="'+tid+'"]'); if(!block) return;
  if(data.vtype){
    block.querySelectorAll('.vtype-card').forEach(function(c){c.classList.remove('selected');});
    var card=block.querySelector('.vtype-card[data-vtype="'+data.vtype+'"]');if(card)card.classList.add('selected');
    block.querySelector('.vtype-hidden').value=data.vtype;
    var cc=block.querySelector('.conditional-fields');
    cc.innerHTML=buildConditionalFields(tid,data.vtype,data);cc.classList.add('visible');
    if(data.color){var opt=block.querySelector('.color-picker__option[data-value="'+data.color+'"]');if(opt)opt.classList.add('selected');}
  }
  showToast('Vehicle 1 info copied');
}
window.copyFromFirst = copyFromFirst;

function duplicateVehicle(sid) {
  var data=getVehicleData(sid);if(!data)return;
  createVehicleBlock(data);
  showToast('Vehicle duplicated');
  container.lastElementChild.scrollIntoView({behavior:'smooth',block:'center'});
}
window.duplicateVehicle = duplicateVehicle;

function removeVehicle(bid) {
  var blocks=container.querySelectorAll('.vehicle-block');if(blocks.length<=1)return;
  var block=container.querySelector('.vehicle-block[data-id="'+bid+'"]');if(!block)return;
  block.style.cssText='animation:none;opacity:0;transform:translateY(-8px);transition:all 0.2s ease;';
  setTimeout(function(){block.remove();updateVehicleNumbers();},200);
}
window.removeVehicle = removeVehicle;

function updateVehicleNumbers() {
  var blocks=container.querySelectorAll('.vehicle-block');
  blocks.forEach(function(block,i){
    var n=i+1; block.querySelector('.vb-num').textContent=n;
    var ad=block.querySelector('.vehicle-block__actions'),bid=block.dataset.id;
    var h='';
    if(n>1)h+='<button type="button" class="btn-vehicle-action btn-copy" onclick="copyFromFirst('+bid+')">'+icons.copy+' Copy from Vehicle 1</button>';
    h+='<button type="button" class="btn-vehicle-action btn-duplicate" onclick="duplicateVehicle('+bid+')">'+icons.duplicate+' Duplicate</button>';
    if(n>1)h+='<button type="button" class="btn-vehicle-action btn-remove" onclick="removeVehicle('+bid+')">'+icons.remove+' Remove</button>';
    ad.innerHTML=h;
  });
  countDisplay.textContent=blocks.length;
}

// ───────────────────────────────────────
//  COLOR PICKER
// ───────────────────────────────────────
function selectColor(bid, el) {
  var pk=el.closest('.color-picker'),tr=pk.querySelector('.color-picker__trigger'),dd=pk.querySelector('.color-picker__dropdown'),hd=pk.querySelector('.color-picker__hidden'),oi=pk.querySelector('.color-picker__other-input'),ts=tr.querySelector('.color-picker__trigger-swatch'),tl=tr.querySelector('.color-picker__trigger-label');
  var v=el.dataset.value,l=el.dataset.label,hex=el.dataset.hex;
  pk.querySelectorAll('.color-picker__option').forEach(function(o){o.classList.remove('selected');});el.classList.add('selected');
  tl.textContent=l;tl.classList.remove('placeholder');
  if(v==='other'){ts.style.background='linear-gradient(135deg,#3A3A3A 25%,#2A2A2A 25%,#2A2A2A 50%,#3A3A3A 50%,#3A3A3A 75%,#2A2A2A 75%)';ts.style.backgroundSize='8px 8px';ts.innerHTML='<span style="font-size:12px;font-weight:700;color:#7D7D7D;">?</span>';oi.classList.add('visible');hd.value='other';setTimeout(function(){oi.focus();},150);}
  else{ts.style.background=hex;ts.style.backgroundSize='';ts.innerHTML='';oi.classList.remove('visible');oi.value='';hd.value=v;}
  dd.classList.remove('open');tr.classList.remove('open');
}
window.selectColor = selectColor;

function toggleColorDropdown(bid) {
  var pk=document.querySelector('.color-picker[data-block="'+bid+'"]'),tr=pk.querySelector('.color-picker__trigger'),dd=pk.querySelector('.color-picker__dropdown');
  document.querySelectorAll('.color-picker__dropdown.open').forEach(function(d){if(d!==dd){d.classList.remove('open');d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open');}});
  var o=dd.classList.toggle('open');tr.classList.toggle('open',o);
}
window.toggleColorDropdown = toggleColorDropdown;

document.addEventListener('click',function(e){if(!e.target.closest('.color-picker')){document.querySelectorAll('.color-picker__dropdown.open').forEach(function(d){d.classList.remove('open');d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open');});}});
document.addEventListener('input',function(e){if(e.target.classList.contains('color-picker__other-input')){e.target.closest('.color-picker').querySelector('.color-picker__hidden').value='other:'+e.target.value;}});

// Year handlers
document.addEventListener('change',function(e){if(e.target.classList.contains('year-select')){var vb=e.target.closest('.vehicle-block'),n=vb.querySelector('.older-vehicle-notice'),yi=vb.querySelector('.older-year-input'),yh=vb.querySelector('.year-hidden');if(e.target.value==='older'){n.classList.add('visible');yh.value='';setTimeout(function(){yi.focus();},100);}else{n.classList.remove('visible');yi.value='';yh.value=e.target.value;}}});
document.addEventListener('input',function(e){if(e.target.classList.contains('older-year-input')){e.target.closest('.vehicle-block').querySelector('.year-hidden').value=e.target.value;}});

// Init Color Change Dropdown
document.getElementById('colorchangeDropdown').innerHTML = buildColorOptionsHTML('colorchange', wrapColors);

// ───────────────────────────────────────
//  REVIEW SUMMARY
// ───────────────────────────────────────
var serviceLabels = {
  printed_wraps:'Printed Wraps', color_change:'Full Color Change Wrap', styling_graphics:'Printed Styling Graphics',
  tuxedo_roof:'Tuxedo / Roof Wraps', chrome_delete:'Chrome Delete', custom_taillights:'Custom Taillights',
  racing_stripes:'Racing Stripes', custom_decals:'Custom Decals', window_flags:'Back Window Flags', other:'Other'
};
var timelineLabels = { asap:'ASAP / As soon as possible', '30_days':'Within 30 days', '30_60_days':'30\u201360 days', '60_90_days':'60\u201390+ days', planning:'Just planning / gathering info' };
var budgetLabels = { '100_500':'$100 \u2013 $500', '600_1200':'$600 \u2013 $1,200', '1200_2400':'$1,200 \u2013 $2,400', '2400_4800':'$2,400 \u2013 $4,800', '4800_6000':'$4,800 \u2013 $6,000', not_sure:'Not sure yet' };

function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
function summaryRow(label,value){return '<div class="summary__row"><span class="summary__label">'+label+'</span><span class="summary__value">'+(value||'<span style="color:#555;">\u2014</span>')+'</span></div>';}
function editBtn(step){return '<button type="button" class="btn-edit" onclick="goToStep('+step+')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>';}
function sectionHeader(num,title,step){return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">'+num+'</span> '+title+'</div>'+editBtn(step)+'</div>';}

function buildSummary() {
  var html = '';
  // 1. Contact
  html += '<div class="summary__section">'+sectionHeader('01','Contact Info',1);
  html += summaryRow('Name', esc(document.getElementById('contactName').value));
  html += summaryRow('Email', esc(document.getElementById('email').value));
  html += summaryRow('Phone', esc(document.getElementById('phone').value));
  var cm=document.getElementById('contactMethodHidden').value;
  html += summaryRow('Preferred', cm==='email'?'Email':cm==='text'?'Text':cm==='call'?'Call':'');
  html += '</div>';

  // 2. Vehicles
  html += '<div class="summary__section">'+sectionHeader('02','Vehicle Details',2);
  document.querySelectorAll('#vehicleBlocksContainer .vehicle-block').forEach(function(block,idx){
    var bid=block.dataset.id, data=getVehicleData(bid); if(!data) return;
    var vtObj=vehicleTypes.find(function(v){return v.value===data.vtype;});
    var colorVal='\u2014';
    if(data.color){if(data.color==='other'&&data.colorOther)colorVal=data.colorOther;else{var cm2=vehicleColors.find(function(c){return c.value===data.color;});if(cm2)colorVal=cm2.label;}}
    html += '<div class="summary__vehicle-card"><div class="summary__vehicle-label">Vehicle '+(idx+1)+'</div>';
    html += summaryRow('Type', esc(vtObj?vtObj.label:'\u2014'));
    html += summaryRow('Year', esc(data.year||'\u2014'));
    html += summaryRow('Make', esc(data.make||'\u2014'));
    html += summaryRow('Model', esc(data.model||'\u2014'));
    html += summaryRow('Color', esc(colorVal));
    if(vtObj&&data.conditionals) vtObj.fields.forEach(function(fk){var fd=conditionalOptions[fk];if(fd&&data.conditionals[fk])html+=summaryRow(fd.label,esc(data.conditionals[fk]));});
    if(data.paintIssue) html += summaryRow('Paint Issues', 'Yes'+(data.paintDesc?' \u2014 '+esc(data.paintDesc):''));
    if(data.browsing) html += summaryRow('Note','Exploring options \u2014 don\'t have vehicle yet');
    html += '</div>';
  });
  html += '</div>';

  // 3. Services
  html += '<div class="summary__section">'+sectionHeader('03','Styling Services',3);
  var svcs=document.getElementById('servicesHidden').value;
  if(svcs){html+=summaryRow('Services', svcs.split(',').map(function(s){return serviceLabels[s]||s;}).join(', '));}
  else html+=summaryRow('Services','\u2014');
  html += '</div>';

  // 4. Timeline & Budget
  html += '<div class="summary__section">'+sectionHeader('04','Timeline & Budget',4);
  html += summaryRow('Timeline', timelineLabels[document.getElementById('timeline').value]||'\u2014');
  var bg=document.getElementById('budget').value;
  if(bg) html += summaryRow('Budget', budgetLabels[bg]||'\u2014');
  html += '</div>';

  document.getElementById('summaryContainer').innerHTML = html;
}

// ───────────────────────────────────────
//  UTILS
// ───────────────────────────────────────
function showToast(m){var t=document.getElementById('stylingToast');t.textContent=m;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2200);}
function showFileNames(i,uid){var el=document.querySelector('#'+uid+' .file-names');if(el) el.textContent=i.files.length?Array.from(i.files).map(function(f){return f.name;}).join(', '):'';}
window.showFileNames = showFileNames;

document.getElementById('btnAddVehicle').addEventListener('click',function(){createVehicleBlock();container.lastElementChild.scrollIntoView({behavior:'smooth',block:'center'});});

// ───────────────────────────────────────
//  SUPABASE FILE UPLOAD HELPER
// ───────────────────────────────────────
function generateSubmissionId() {
  var ts = Date.now();
  var rand = Math.random().toString(36).substring(2, 8);
  return ts + '_' + rand;
}

async function uploadFileToSupabase(file, path) {
  var url = FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  try {
    var resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type || 'application/octet-stream',
        'x-upsert': 'true'
      },
      body: file
    });
    if (!resp.ok) throw new Error('Upload failed: ' + resp.status);
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  } catch (err) {
    console.error('File upload error:', err);
    return null;
  }
}

async function uploadFilesFromInput(inputEl, submissionId, folder) {
  if (!inputEl || !inputEl.files || inputEl.files.length === 0) return [];
  var urls = [];
  for (var i = 0; i < inputEl.files.length; i++) {
    var file = inputEl.files[i];
    var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    var path = 'submissions/' + submissionId + '/' + folder + '/' + safeName;
    var publicUrl = await uploadFileToSupabase(file, path);
    if (publicUrl) urls.push(publicUrl);
  }
  return urls;
}

// ───────────────────────────────────────
//  FORM SUBMISSION
// ───────────────────────────────────────
document.getElementById('fwgStylingForm').addEventListener('submit', async function(e) {
  e.preventDefault();

  // Validate all steps
  for (var i = 1; i <= TOTAL_STEPS; i++) {
    var errors = getStepErrors(i);
    if (errors.length > 0) { switchCard(i); setTimeout(function(){ highlightErrors(i, errors); }, 50); showToast('Please fill in all required fields'); return; }
  }

  var submitBtn = document.querySelector('.btn-submit');
  var originalText = submitBtn.textContent;
  submitBtn.textContent = 'Submitting...';
  submitBtn.disabled = true;
  submitBtn.style.opacity = '0.6';

  try {
    var submissionId = generateSubmissionId();

    // Upload vehicle photos
    var vehicleBlocks = document.querySelectorAll('#vehicleBlocksContainer .vehicle-block');
    var vehicles = [];
    for (var vi = 0; vi < vehicleBlocks.length; vi++) {
      var block = vehicleBlocks[vi];
      var bid = block.dataset.id;
      var data = getVehicleData(bid);
      if (!data) continue;

      var vtObj = vehicleTypes.find(function(v) { return v.value === data.vtype; });
      var photoInput = block.querySelector('input[name="v' + bid + '_photos"]');
      var photoUrls = await uploadFilesFromInput(photoInput, submissionId, 'vehicle_' + bid);

      vehicles.push({
        type: data.vtype,
        type_label: vtObj ? vtObj.label : data.vtype,
        year: data.year,
        make: data.make,
        model: data.model,
        color: data.color,
        color_other: data.colorOther,
        browsing: data.browsing,
        paint_issue: data.paintIssue,
        paint_desc: data.paintDesc,
        conditionals: data.conditionals,
        photo_urls: photoUrls
      });
    }

    // Upload service-specific files
    var serviceFileUploads = {};
    var serviceFileInputs = {
      printed_wraps: 'svc_printed_wraps_files',
      styling_graphics: 'svc_styling_graphics_files',
      tuxedo_roof: 'svc_tuxedo_files',
      chrome_delete: 'svc_chrome_delete_files',
      custom_taillights: 'svc_taillights_files',
      racing_stripes: 'svc_stripes_files',
      custom_decals: 'svc_decals_files',
      window_flags: 'svc_flags_files',
      other: 'svc_other_files'
    };

    for (var svcKey in serviceFileInputs) {
      if (selectedServices.has(svcKey)) {
        var svcInput = document.querySelector('input[name="' + serviceFileInputs[svcKey] + '"]');
        serviceFileUploads[svcKey] = await uploadFilesFromInput(svcInput, submissionId, 'services/' + svcKey);
      }
    }

    // Upload reference images from review step
    var refInput = document.querySelector('input[name="ref_images"]');
    var refUrls = await uploadFilesFromInput(refInput, submissionId, 'reference');

    // Collect service details
    var serviceDetails = {};
    if (selectedServices.has('printed_wraps')) {
      serviceDetails.printed_wraps = {
        description: (document.querySelector('[name="svc_printed_wraps_desc"]') || {}).value || '',
        file_status: (document.getElementById('printed_wraps_file_status') || {}).value || '',
        file_urls: serviceFileUploads.printed_wraps || []
      };
    }
    if (selectedServices.has('color_change')) {
      serviceDetails.color_change = {
        color: (document.querySelector('[name="svc_color_change_color"]') || {}).value || '',
        finish: (document.querySelector('[name="svc_color_change_finish"]') || {}).value || '',
        notes: (document.querySelector('[name="svc_color_change_notes"]') || {}).value || ''
      };
    }
    if (selectedServices.has('styling_graphics')) {
      serviceDetails.styling_graphics = {
        description: (document.querySelector('[name="svc_styling_graphics_desc"]') || {}).value || '',
        file_status: (document.getElementById('styling_graphics_file_status') || {}).value || '',
        file_urls: serviceFileUploads.styling_graphics || []
      };
    }
    if (selectedServices.has('tuxedo_roof')) {
      serviceDetails.tuxedo_roof = {
        type: (document.getElementById('tuxedoTypeHidden') || {}).value || '',
        look: (document.getElementById('tuxedoLookHidden') || {}).value || '',
        file_urls: serviceFileUploads.tuxedo_roof || []
      };
    }
    if (selectedServices.has('chrome_delete')) {
      serviceDetails.chrome_delete = {
        description: (document.querySelector('[name="svc_chrome_delete_desc"]') || {}).value || '',
        file_urls: serviceFileUploads.chrome_delete || []
      };
    }
    if (selectedServices.has('custom_taillights')) {
      serviceDetails.custom_taillights = {
        description: (document.querySelector('[name="svc_taillights_desc"]') || {}).value || '',
        pattern: (document.querySelector('[name="svc_taillights_pattern"]') || {}).value || '',
        file_urls: serviceFileUploads.custom_taillights || []
      };
    }
    if (selectedServices.has('racing_stripes')) {
      serviceDetails.racing_stripes = {
        description: (document.querySelector('[name="svc_stripes_desc"]') || {}).value || '',
        file_urls: serviceFileUploads.racing_stripes || []
      };
    }
    if (selectedServices.has('custom_decals')) {
      serviceDetails.custom_decals = {
        description: (document.querySelector('[name="svc_decals_desc"]') || {}).value || '',
        file_urls: serviceFileUploads.custom_decals || []
      };
    }
    if (selectedServices.has('window_flags')) {
      serviceDetails.window_flags = {
        description: (document.querySelector('[name="svc_flags_desc"]') || {}).value || '',
        file_urls: serviceFileUploads.window_flags || []
      };
    }
    if (selectedServices.has('other')) {
      serviceDetails.other = {
        description: (document.querySelector('[name="svc_other_desc"]') || {}).value || '',
        file_urls: serviceFileUploads.other || []
      };
    }

    // Build payload — maps to form_submissions table columns
    var payload = {
      form_type: 'automotive_styling',
      contact_name: document.getElementById('contactName').value.trim(),
      email: document.getElementById('email').value.trim(),
      phone: document.getElementById('phone').value.trim(),
      contact_method: document.getElementById('contactMethodHidden').value,
      vehicles: vehicles,
      services: Array.from(selectedServices),
      service_details: serviceDetails,
      timeline: document.getElementById('timeline').value,
      budget: document.getElementById('budget').value || null,
      additional_info: (document.getElementById('additionalInfo') || {}).value || null,
      reference_image_urls: refUrls,
      source_page: window.location.pathname,
      user_agent: navigator.userAgent
    };

    // Submit through API
    var response = await fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      var errText = await response.text();
      console.error('API response:', errText);
      throw new Error('Submission failed: ' + response.status);
    }

    showToast('Quote request submitted!');
    setTimeout(function() {
      window.location.href = FWG_CONFIG.THANK_YOU_URL;
    }, 800);

  } catch (err) {
    console.error('Submission error:', err);
    showToast('Something went wrong. Please try again.');
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
    submitBtn.style.opacity = '1';
  }
});

// Init first vehicle block
createVehicleBlock();

}); // end DOMContentLoaded
